import "./LibrariesImport";

// SmoothScroll has to be first
import SmoothScroll from "./animations/SmoothScroll";

import ResizeEvents from "./events/ResizeEvents";
import EventListeners from "./events/EventListeners";
import LazyLoadImages from "./events/ImageLoaded";

import MobileCheck from "./utils/MobileCheck";
import DevHelpers from "./utils/DevHelpers";

// import Forms from "./components/Forms";
import Buttons from "./components/Buttons";
import Gallery from "./components/Gallery";
import RichText from "./components/RichText";

import AppearOnScroll from "./data-attributes/AppearOnScroll";
import DataLink from "./data-attributes/DataLink";
import DataBatch from "./data-attributes/DataBatch";
import MatchHeight from "./data-attributes/MatchHeight";
import Parallax from "./data-attributes/Parallax";
import TextAppear from "./data-attributes/TextAppear";

LazyLoadImages.init();

export default class StarterKit {
	static init() {
		console.log("%cFabriqué à Lyon par mcube️", "background-color:#211450; color:#FF407D;padding:3px 5px;font-family:monospace;", "www.mcube.fr");

		this.resizeTimer = null;
		this.fixHeightMobile();
		window.addEventListener('resize', this.OnResize);

		SmoothScroll.init();

		ResizeEvents.init();
		EventListeners.init();

		MobileCheck.init();
		DevHelpers.init();

		// Forms.init();

		AppearOnScroll.init();
		DataLink.init();
		DataBatch.init();
		MatchHeight.init();
		Parallax.init();
		TextAppear.init();
		Buttons.init();
		RichText.init();
		Gallery.init();
	}

	static onResize(){
		clearTimeout(this.resizeTimer);
		this.resizeTimer = setTimeout(this.fixHeightMobile, 200);
	}

	static fixHeightMobile(){
		// We execute the same script as before
		let vh = window.innerHeight * 0.01;
		document.documentElement.style.setProperty('--vh', `${vh}px`);
	}

}
